import React from 'react';
import * as PropTypes from 'prop-types';
import {
    Layout, Row, Typography,
} from 'antd';
import './Panels.css';

const { Text } = Typography;


const BannerPanel = ({ title, children }) => {
  return (
    <Layout className="dp-panel-frame-light">
        <Row className="dp-banner-panel-banner">
            <Text className="dp-banner-panel-title">{title}</Text>
        </Row>
        <Row className="dp-banner-panel-main">
            {children}
        </Row>
    </Layout>
  );
}

// Validate the prop type parameters.
BannerPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

export default BannerPanel;
